import { Box, CircularProgress, Alert, List, ListItem, ListItemText, ListItemButton, ListItemAvatar, Avatar } from '@mui/material';
import { GradientText } from '../../utils/theme';
import useDelivery from '../hooks/useDelivery';
import FolderIcon from '@mui/icons-material/Folder';

const Delivery = () => {
  const { deliveries, loading, error } = useDelivery();

  if (loading) {
    return <CircularProgress />;
  }

  if (error) {
    return <Alert severity="error">{error}</Alert>;
  }


  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'flex-start', flexDirection: 'column', minHeight: '60vh', bgcolor: 'grey.100', mt: 2, borderRadius: 1, mx: 'auto', width: '80%' }}>
      <GradientText variant="h6" gutterBottom sx={{ mt: 3 }}>
        納品書一覧
      </GradientText>
      <List sx={{ width: '100%', ml: -2 }}>
      {deliveries.length === 0 ? (
          <ListItem>
            <ListItemText primary="納品書はありません。" />
          </ListItem>
        ) : (
          deliveries.map((delivery) => (
            <ListItem key={`${delivery.id}-${delivery.delivery_date}`}>
              <ListItemButton
                onClick={() => window.open(delivery.pdf_link, '_blank')}
                sx={{
                  '&:hover': {
                    backgroundColor: 'rgba(0, 0, 0, 0.08)',
                  }
                }}
              >
              <ListItemAvatar sx={{ minWidth: 40 }}>
                  <Avatar>
                    <FolderIcon />
                  </Avatar>
                </ListItemAvatar>
              <ListItemText
                primary={`納品日: ${delivery.delivery_date}`}
                sx={{ ml: 1.5, whiteSpace: 'nowrap' }}
              />
              </ListItemButton>
            </ListItem>
          ))
        )}
      </List>
    </Box>
  );
};

export default Delivery;
